import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-spinner',
  templateUrl: './spinner.component.html',
  styleUrls: ['./spinner.component.scss']
})
export class SpinnerComponent {
@Input() size: 'sm' | 'md' | 'lg' = 'sm';
  @Input() color: string = 'text-primary';

  get spinnerClasses(): string[] {
    return ['spinner-border', this.sizeClass, this.color];
  }

  private get sizeClass(): string {
    switch (this.size) {
      case 'lg':
        return 'spinner-border-lg';
      case 'md':
        return '';
      default:
        return 'spinner-border-sm';
    }
  }
}
